// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_1vWWFuqu4rQLOwirES2imu"};